const us_en = {
    logo: 'botopus',
    about_us: 'About US',
    user_cases: 'Use Cases',
    contact_us: `Let's Talk`,
    services : 'Services',
    slogan_title : 'We are your own IT',
    slogan_button_text : 'user cases',
    contact_us_sec_title : "Let's Talk",
    contact_us_sec_summary : 'We are good listeners',
    services_sec_title : 'We are different',
    services_sec_fea_expert : 'Experts in the team',
    services_sec_fea_expert_intro : 'Experts are deeply participated in every stages of solutions',
    services_sec_fea_agile : 'Agile Deliveries',
    services_sec_fea_agile_intro : 'Deliver to customers in time and bring values to customers at the first place',
    services_sec_fea_worth : 'Right solutions',
    services_sec_fea_worth_intro : 'Only provide right solutions instead of expensive solutions. Rights solutions means it fit you now and future',
    services_sec_fea_integration : 'Integration',
    services_sec_fea_integration_intro : 'Integration of software and hardware is the root of a right solution',
    services_sec_fea_cust : 'Customization',
    services_sec_fea_cust_intro : 'Understand your needs, and help you on achieving your goals',
    services_sec_fea_full : 'All in one',
    services_sec_fea_full_intro : 'Solutions are provided in a fully consideration mind, end to end manner',
    footer_sec_partner_title : 'Partners',
    footer_sec_partner_1 : 'ZUAD',

}

export default us_en;


// WEBPACK FOOTER //
// ./src/en_us.js